import { ANALYZE_METHODS } from '@/features/analyze/constants';
import { AnalyzeMethod } from '@/features/analyze/types';
import { useLocation } from 'react-router-dom';

const isAnalyzeMethod = (value: string): value is AnalyzeMethod => {
  return ANALYZE_METHODS.includes(value);
};

export const useGetAnalyzeMethod = () => {
  const { pathname } = useLocation();

  const regex = /^\/analyze\/([^/]+)\/?$/;
  const matched = pathname.match(regex);

  if (!matched || !isAnalyzeMethod(matched[1])) return null;
  return matched[1];
};
